import { useQuery } from "@msuite/ui/query";
import { DataTable } from "@msuite/ui/table";
import { responseHandler } from "@msuite/ui/utils";
import { guardArray } from "@msuite/utils/array";
import { client } from "@/hono";
import type { ArticlePanelBaseProps } from "../shared";
import { columns } from "./table-config";

export function ArticleTransactions({ articleId }: ArticlePanelBaseProps) {
	/** Query */
	const { data, isLoading, refetch, queryKey } = useQuery({
		queryKey: ["article-transactions", articleId],
		queryFn: async () => {
			const response = await client.stock.articles[":articleId"].transactions.$get({
				param: { articleId },
			});
			const data = await responseHandler(response);
			return guardArray(data.transactions);
		},
	});

	/** Render */
	return (
		<DataTable
			data={guardArray(data)}
			columns={columns}
			refetch={refetch}
			isLoading={isLoading}
			queryKey={queryKey}
			menu={null}
			persistenceKey="article-transactions-table"
		/>
	);
}
